<template>
  <div>
      <!--吹き出しはじまり-->
      <div class="balloon-q">
          <div class="face-icon">
            <v-img src="/img/q-human.png" />
          </div>
          <div class="chatting">
              <div class="says-q">
                  <p>遊ぶ順番は？</p>
              </div>
          </div>
      </div>
      <!--吹き出し終わり-->
      <!--吹き出しはじまり-->
      <div class="balloon-a">
          <div class="face-icon">
            <v-img src="/img/pafu_256.png" />
          </div>
          <div class="chatting">
              <div class="says-a">
                  <p>
                      特別な事情を除き、完全ランダムです！<br>
                  </p>
              </div>
          </div>
      </div>
      <!--吹き出し終わり-->
  </div>

  <div>
      <!--吹き出しはじまり-->
      <div class="balloon-q">
          <div class="face-icon">
              <v-img src="/img/q-human.png" />
          </div>
          <div class="chatting">
              <div class="says-q">
                  <p>仕事や遊びで、この日には見れないんだけど...？</p>
              </div>
          </div>
      </div>
      <!--吹き出し終わり-->
      <!--吹き出しはじまり-->
      <div class="balloon-a">
          <div class="face-icon">
              <v-img src="/img/pafu_256.png" />
          </div>
          <div class="chatting">
              <div class="says-a">
                  <p>
                      Twitterにて是非ご連絡下さい！<br>
                      ご連絡頂ければ、プレイする日を指定することも可能です！@ツイートorDMでどうぞ！
                  </p>
              </div>
          </div>
      </div>
      <!--吹き出し終わり-->
  </div>

  <div>
      <!--吹き出しはじまり-->
      <div class="balloon-q">
          <div class="face-icon">
              <v-img src="/img/q-human.png" />
          </div>
          <div class="chatting">
              <div class="says-q">
                  <p>遅れて提出しても大丈夫？</p>
              </div>
          </div>
      </div>
      <!--吹き出し終わり-->
      <!--吹き出しはじまり-->
      <div class="balloon-a">
          <div class="face-icon">
              <v-img src="/img/pafu_256.png" />
          </div>
          <div class="chatting">
              <div class="says-a">
                  <p>
                      放送期間内でしたら放送します！<br>
                      ですが、他の方々に遊ばれづらいので頑張って完成を目指してください！
                  </p>
              </div>
          </div>
      </div>
      <!--吹き出し終わり-->
  </div>

  <div>
      <!--吹き出しはじまり-->
      <div class="balloon-q">
          <div class="face-icon">
              <v-img src="/img/q-human.png" />
          </div>
          <div class="chatting">
              <div class="says-q">
                  <p>オンラインゲームを作ってるんだけど...？</p>
              </div>
          </div>
      </div>
      <!--吹き出し終わり-->
      <!--吹き出しはじまり-->
      <div class="balloon-a">
          <div class="face-icon">
              <v-img src="/img/pafu_256.png" />
          </div>
          <div class="chatting">
              <div class="says-a">
                  <p>
                      Twitterにて是非ご連絡を！<br>
                      オンラインゲームを視聴者とプレイする日時を決めます！@ツイート or DMでどうぞ！
                  </p>
              </div>
          </div>
      </div>
      <!--吹き出し終わり-->
  </div>

  <div>
      <!--吹き出しはじまり-->
      <div class="balloon-q">
          <div class="face-icon">
              <v-img src="/img/q-human.png" />
          </div>
          <div class="chatting">
              <div class="says-q">
                  <p>クオリティが低いのですが...大丈夫？</p>
              </div>
          </div>
      </div>
      <!--吹き出し終わり-->
      <!--吹き出しはじまり-->
      <div class="balloon-a">
          <div class="face-icon">
              <v-img src="/img/pafu_256.png" />
          </div>
          <div class="chatting">
              <div class="says-a">
                  <p>
                      悪口はもちろん、ブラウザバックも絶対にしませんのでご安心を！<br>
                      どんなゲームでも楽しくプレイすることに定評があります！<br>
                      実況されたくない場合、お手数ですがご連絡をお願いします。
                  </p>
              </div>
          </div>
      </div>
      <!--吹き出し終わり-->
  </div>
</template>

<script>
</script>

<style scoped>
h2 {
  position: relative;
  background: #ffd98a;
  padding: 2px 5px 2px 25px;
  font-size: 24px;
  color: #474747;
  border-radius: 0 10px 10px 0;
}

h2 .icon {
  font-family: "Font Awesome 5 Free";
  display: inline-block;
  position: absolute;
  padding: 0em;
  color: white;
  background: #ffa337;
  font-weight: normal;
  width: 40px;
  text-align: center;
  height: 40px;
  line-height: 35px;
  left: -1.35em;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  border: solid 3px white;
  border-radius: 50%;
}

/* 吹き出し Q */

.balloon-q {
  width: 100%;
  margin: 1.5em 0;
  overflow: hidden;
}

.balloon-q .face-icon {
  float: left;
  margin-right: -90px;
  width: 80px;
}

.balloon-q .face-icon img{
  width: 100%;
  height: auto;
  border: solid 3px #cbffc5;
  border-radius: 50%;
}

.balloon-q .chatting {
  width: 100%;
}

.says-q {
  display: inline-block;
  position: relative;
  margin: 5px 0 0 105px;
  padding: 17px 13px;
  border-radius: 12px;
  background: #cbffc5;
}

.says-q:after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 18px;
  left: -24px;
  border: 12px solid transparent;
  border-right: 12px solid #cbffc5;
}

.says-q p {
  margin: 0;
  padding: 0;
}

/* 吹き出し A */

.balloon-a {
  width: 100%;
  margin: 1.5em 0;
  overflow: hidden;
}

.balloon-a .face-icon {
  float: left;
  margin-right: -90px;
  width: 80px;
}

.balloon-a .face-icon img{
  width: 100%;
  height: auto;
  border: solid 3px #d7ebfe;
  border-radius: 50%;
}

.balloon-a .chatting {
  width: 100%;
}

.says-a {
  display: inline-block;
  position: relative;
  margin: 5px 0 0 105px;
  padding: 17px 13px;
  border-radius: 12px;
  background: #d7ebfe;
}

.says-a:after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 18px;
  left: -24px;
  border: 12px solid transparent;
  border-right: 12px solid #d7ebfe;
}

.says-a p {
  margin: 0;
  padding: 0;
}

/* アーカイブ用 */
.play-list-title {
  background: linear-gradient(transparent 0%, #ffc778 0%);
    width: 160px;
    font-size: 20px;
}

.play-list-box {
    border: solid 2px #ffb107;
  line-height: 2em;
}

/* プレイリスト用 */
ol {
  counter-reset:number; /*数字をリセット*/
  list-style-type: none!important; /*数字を一旦消す*/
  padding: 0.3em 0.8em;
  border: solid 2px #ffb107;
}
ol li {
  border-bottom: dashed 1px orange;
  position: relative;
  padding: 0.5em 0.5em 0.5em 30px;
  line-height: 1.5em;
}
ol li:before{
  /* 以下数字をつける */
  position: absolute;
  counter-increment: number;
  content: counter(number);
  /*数字のデザイン変える*/
  display:inline-block;
  background: #ffb107;
  color: white;
  font-family: 'Avenir','Arial Black','Arial',sans-serif;
  font-weight:bold;
  font-size: 15px;
  left: 0;
  width: 37.5px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  /*以下 上下中央寄せのため*/
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
ol li:last-of-type {
  border-bottom: none; /*最後のliの線だけ消す*/
}

/* Playボタン */
.btn-play {
  position: relative;
  display: inline-block;
  padding: 0.25em 0.5em;
  text-decoration: none;
  color: #FFF;
  background: #fd9535;/*色*/
  border-radius: 4px;/*角の丸み*/
  box-shadow: inset 0 2px 0 rgba(255,255,255,0.2), inset 0 -2px 0 rgba(0, 0, 0, 0.05);
  font-weight: bold;
  border: solid 2px #d27d00;/*線色*/
}

.btn-play:active {
  /*押したとき*/
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.30);
}
</style>